export enum QueryKeys {
  MimVersion = 'mimVersion',
  GroupedAlerts = 'groupedAlerts',
  FiscalCalendar = 'fiscalCalendar'
}
